import _ from 'underscore';

import BaseView from '../../../base-view';
import Model from '../model';
import template from './template.html';

export default BaseView.extend({
	className: 'blink-attention',

	events: {
		'change input[type="checkbox"]': 'onCheckboxChange'
	},

	tagName: 'li',
	template: _.template(template),

	initialize: function(options) {
		this.model = this.model || new Model();

		// reference elements
		this.cacheElements();

		// listeners
		this.listenTo(this.model, 'change:MinutesLeft', this.onMinutesLeftChange);
		this.listenTo(this.model, 'change:NotificationSentString', this.onNotificationSentChange);
		this.listenTo(this.model, 'change:IsSelected', this.onSelectedChange);
	},

	/**
	 * references to elements within the el
	 **/
	cacheElements: function() {
		this.checkbox = this.query('input[type="checkbox"]');
		this.minutesleft = this.query('.js-minutes-left');
		this.notificationTime = this.query('.js-notification-sent');
	},

	/**
	 * item selection has changed
	 **/
	onCheckboxChange: function(e) {
		var selected = e.target.checked;
		this.model.set('IsSelected', selected);
	},

	/**
	 * Model IsSelected change handler
	 **/
	onSelectedChange: function(model, isSelected) {
		this.checkbox.checked = isSelected;
	},

	/**
	 * Update time left in element
	 **/
	onMinutesLeftChange: function(model) {
		this.minutesleft.innerHTML = model.get('MinutesLeft');
	},

	/**
	 * Update notification time in element
	 **/
	onNotificationSentChange: function(model) {
		this.notificationTime.innerHTML = model.get('NotificationSentString');
	},

	/**
	 * Fill el with template HTML
	 * note: don't render if a existing DOM element is attached to this view
	 **/
	render: function() {
		this.el.innerHTML = this.template(this.model.toJSON());

		// re-cache elements after render
		this.cacheElements();

		return this;
	}
});
